<template>
  <q-page class="page-background">
    <div class="row q-pa-md justify-around">
      <map-component :markers="markers"  class="frosted col-10 col-md-7" />
      <map-card class="col-10 col-md-2"/>
    </div>
  </q-page>
</template>

<style lang="scss">
.page-background {
  background-image: url("../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.frosted {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 6.5px solid rgba(255, 255, 255, 0.18);
}
</style>

<script>
import MapCard from '../components/MapCard.vue';
import MapComponent from "../components/MapComponent.vue";

export default {
  components: { MapComponent, MapCard },
  data() {
    return {
      
      markers: [
        {
          position: {
            lat: 51.093048,
            lng: 6.84212
          },
          data:{
            clinic:"Queen Maria",
            doctor:"Izikiel Borikova",
            specialization: "Endocrinology",
            schedule: "8:00 AM - 18:00 PM",
            phone:"+40712345678",
            address: "Bd. Unirii 85, Sector 3, Bucharest, Et. 5",
          }
        },
        {
          position: {
            lat: 51.198429,
            lng: 6.69529
          },
          data:{
            clinic:"Sanador",
            doctor:"Horia Brenciu",
            specialization: "Infectious diseases",
            schedule: "5:00 AM - 12:00 PM",
            phone:"+40713513523",
            address: "Bd. adfgsdhsfgjghjdghjdgh",
          }
        },
        {
          position: {
            lat: 51.165218,
            lng: 7.067116
          },
          data:{
            clinic:"Ulambator",
            doctor:"Mishbake",
            specialization: "Infectious diseases",
            schedule: "5:00 AM - 12:00 PM",
            phone:"+40756462252",
            address: "Bd. adfgsdhsfgjghjdghjdgh",
          }
        },
        {
          position: {
            lat: 51.09256,
            lng: 6.84074
          },
          data:{
            clinic:"Corndohg",
            doctor:"Elenor Bakuk",
            specialization: "Infectious diseases",
            schedule: "5:00 AM - 12:00 PM",
            phone:"+40790867567",
            address: "Bd. adfgsdhsfgjghjdghjdgh",
          }
        }
      ]
    };
  },
}
</script>